import useAuth from "@/hooks/useAuth";
import { USER_TYPES } from "@/types/auth";

export function useIsInternalUser(): boolean {
  const { user } = useAuth();
  return user?.user_type === USER_TYPES.INTERNAL;
}
